import React, { memo, useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useTheme } from '../../../contexts/ThemeContext';

import MemoryCard from './MemoryCard';
import SpeedRunCard from './SpeedRunCard';
import DailyCard from './DailyCard';
import WorldMapCard from './WorldMapCard';
import { CARD_GAP } from './cardConstants';
import { spacing } from '../../../utils/responsive';

/**
 * GameModesSection - Bento Grid Layout for Game Modes
 * Cards navigate to their respective screens
 */
const GameModesSection = memo(() => {
    const navigation = useNavigation();
    const { isDarkMode } = useTheme();

    // Navigate to SecondBrain screen (from yellow card)
    const handleSecondBrainPress = useCallback(() => {
        navigation.navigate('SecondBrain');
    }, [navigation]);

    // Navigate to Concursos screen (from black card - Questões de Concurso)
    const handleQuestionsPress = useCallback(() => {
        navigation.navigate('Concursos');
    }, [navigation]);

    // Navigate to FocusMode screen (from World Map card)
    const handleFocusModePress = useCallback(() => {
        navigation.navigate('FocusMode');
    }, [navigation]);

    // Navigate to QuestionSolver with mode 'all' (from Daily card - Questões Aleatórias)
    const handlePracticeAllPress = useCallback(() => {
        navigation.navigate('QuestionSolver', { mode: 'all' });
    }, [navigation]);

    return (
        <View style={styles.container}>
            {/* New Layout: MemoryCard on top, SpeedRunCard below left */}
            <View style={styles.grid}>
                {/* Top Row: Memory Card (full width) - Questões de Concurso */}
                <View style={styles.topRow}>
                    <MemoryCard onPress={handleQuestionsPress} />
                </View>

                {/* Bottom Row: Two columns */}
                <View style={styles.bottomRow}>
                    {/* Left: SpeedRunCard (Segundo Cérebro) */}
                    <View style={styles.bottomLeftColumn}>
                        <SpeedRunCard onPress={handleSecondBrainPress} isDarkMode={isDarkMode} />
                    </View>

                    {/* Right: Daily + World Map stacked */}
                    <View style={styles.bottomRightColumn}>
                        <View>
                            <DailyCard onPress={handlePracticeAllPress} isDarkMode={isDarkMode} />
                        </View>
                        <View>
                            <WorldMapCard onPress={handleFocusModePress} isDarkMode={isDarkMode} />
                        </View>
                    </View>
                </View>
            </View>
        </View>
    );
});

const styles = StyleSheet.create({
    container: {
        marginTop: spacing.sm,
        marginBottom: spacing.sm,
    },

    // New Grid Layout - Vertical
    grid: {
        flexDirection: 'column',
        gap: 6,
    },

    topRow: {
        width: '100%',
    },

    bottomRow: {
        flexDirection: 'row',
        gap: CARD_GAP,
    },

    bottomLeftColumn: {
        flex: 1,
    },

    bottomRightColumn: {
        flex: 1,
        gap: 4,
    },
});

export default GameModesSection;
